import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import { FrotasComponent } from './frotas.component';
import {FrotasRoutingModule} from "./frotas-routing.module";
import {FrotaApiService} from "./shared/frota-api.service";
import {FrotaNavigationService} from "./shared/frota-navigation.service";
import {FrotasService} from "./shared/frota.service";
import {FrotaFormComponent} from "./frota-form/frota-form.component";
import {FrotaListComponent} from "./frota-list/frota-list.component";
import {BemCombustiveisModule} from "../bem-combustiveis/bem-combustiveis.module";
import {FrotaDetailComponent} from "./frota-detail/frota-detail.component";
import {FrotaImagemComponent} from "./frota-imagem/frota-imagem.component";
import {FrotaOdometroHorimetroComponent} from "./frota-odometro-horimetro/frota-odometro-horimetro.component";
import {OdometrosHorimetrosModule} from "../../manutencoes/odometros-horimetros/odometros-horimetros.module";

@NgModule({
    imports: [
        SharedModule,
        BemCombustiveisModule,
        OdometrosHorimetrosModule,
        FrotasRoutingModule
    ],
    providers: [
        FrotaApiService,
        FrotaNavigationService,
        FrotasService
    ],
    declarations: [
        FrotasComponent,
        FrotaFormComponent,
        FrotaListComponent,
        FrotaDetailComponent,
        FrotaImagemComponent,
        FrotaOdometroHorimetroComponent
    ]
})
export class FrotasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frotas.module.ts
 **/